module.exports = __webpack_public_path__ + "static/frn-logo-white.72d98e99.png";